var getTitleFromPath = function (path, fieldNames) {
    if (!path)
        return '';
    var possibleFieldNames = typeof fieldNames === 'string' ? [fieldNames] : fieldNames;
    if (possibleFieldNames.every(function (field) { return !path.includes(field); }) && !path.includes('/'))
        return path;
    var fieldNameOptions = "" + possibleFieldNames.map(function (fieldName) { return "(" + fieldName + ")"; }).join('|');
    var fieldNameIncludingStringFollowingReg = new RegExp("(" + fieldNameOptions + ").*", 'g');
    var fieldNameRegex = new RegExp(fieldNameOptions);
    var beginningOfName = path.search(fieldNameIncludingStringFollowingReg);
    var fileName = path.slice(beginningOfName).split(fieldNameRegex).slice(possibleFieldNames.length + 1).join('');
    return fileName;
};
export default getTitleFromPath;
//# sourceMappingURL=getTitleFromPath.js.map